module.exports = __webpack_public_path__ + "static/img/6.9662ef7.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/1/2/eng/6.png
// module id = IhOR
// module chunks = 0